export interface WizardStepInfo {
  currentStepIndex: number;
  completed?: boolean;
}
